import { useInView } from "react-intersection-observer";

export default function useIntersectionObserver() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px",
  });
  return { ref, inView };
}
